import { parse, toSeconds } from 'iso8601-duration';
import { TariffViewModel } from '@common/model/billing/tariff/view';

export const getPerSecondPrice = (tariff: Pick<TariffViewModel, 'period' | 'price' | 'discount'>): number => {
  const duration = tariff.period ? parse(tariff.period) : { seconds: 1 };
  return (tariff.price - tariff.discount) / toSeconds(duration);
};
